import { useRef, useState } from 'react';
import styles from './Gallery.module.css';
import {GalleryImages} from '../Info';

export default function Gallery() {
    const [selectedImage, setSelectedImage] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(null);
    const modalRef = useRef(null);

    const openModal = (image,index) => {
        setSelectedImage(image);
        setCurrentIndex(index);
        if (modalRef.current) {
            modalRef.current.showModal();
        }
    }


    const closeModal = () => {
        if (modalRef.current) {
            modalRef.current.close();
            modalRef.current.style.display = "none"; 
            setTimeout(() => {
                modalRef.current.style.display = ""; 
                setSelectedImage(null);
            }, 0);
        }
       
    }

    const handleBackdropClick = (event) => {
        if (event.target === modalRef.current) {
            closeModal();
        }
    }

    const handleNext = () => {
        const nextIndex = (currentIndex + 1) % GalleryImages.length;
        setSelectedImage(GalleryImages[nextIndex]);
        setCurrentIndex(nextIndex);
    };

    const handlePrev = () => {
        const prevIndex = (currentIndex - 1 + GalleryImages.length) % GalleryImages.length;
        setSelectedImage(GalleryImages[prevIndex]);
        setCurrentIndex(prevIndex);
    };

    return (
        <section className={styles.GalleryPage} id='gallery'>
            <h2 className={styles.PageName}>Captured Memories</h2>  

            <section className={styles.GridContainer}>
                { GalleryImages.map((image, index) => {
                    return <article key={image.id} className={styles.gridItem} onClick={() => openModal(image, index)}>
                        <img src={`/gallery/${image.thumbnail}`} alt={image.caption} loading='lazy'/>
                        {/* <p>{image.caption}</p> */}
                    </article>
                })}
            </section>

          <dialog ref={modalRef} className={styles.Modal} onClick={handleBackdropClick} >
                {selectedImage && ( 
                    <div className={styles.modalContent}>
                         <button className={styles.prevButton} onClick={handlePrev}>
                            <img src='/icons/previous.png' alt='previous icon' />
                         </button>
                        
                        <img src={`/gallery/${selectedImage.url}`} alt={selectedImage.caption}/>
                        
                        <button className={styles.nextButton} onClick={handleNext}>
                            <img src='/icons/next.png' alt='next icon' />
                        </button>
                        
                        <p className={styles.caption}>{selectedImage.caption}</p>
                
                        <button className={styles.closeButton} onClick={closeModal}>
                            <img src='/icons/close.png' alt='close icon' />
                        </button>
                    </div>
                )}
            </dialog>

        </section>
    )
}